<template>
  <v-dialog v-model="show" persistent :max-width="400">
    <v-card>
      <v-form ref="form" :lazy-validation="true" class="pt-8">
        <v-card-title>STARTDATUM</v-card-title>
        <v-card-actions>
          <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
        </v-card-actions>      
        <v-card-text class="">
          <h6 class="text-uppercase semi-bold pb-1 mt-n4">Ändra startdatum på anställningen</h6>
          <DatePicker 
            ref="startDate"
            v-model="startDate"
            :icon="'$sl-calendar'"
            width="100%"
            outlined
            :required="false"
          />
        </v-card-text>
      </v-form>

      <v-form ref="form" :lazy-validation="true">
        <v-card-title>SLUTDATUM</v-card-title>
        <v-card-actions>
          <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
        </v-card-actions>      
        <v-card-text class="">
          <h6 class="text-uppercase semi-bold pb-1 mt-n4">Ändra slutdatum på anställningen</h6>
          <DatePicker 
            ref="endDate"
            v-model="endDate"
            :icon="'$sl-calendar'"
            width="100%"
            outlined
            :required="false"
          />
        </v-card-text>

        <v-card-actions class="justify-end mt-2">
          <v-btn @click="$emit('close')"> <v-icon>$sl-cancel</v-icon>AVBRYT </v-btn>
          <v-btn color="secondary" @click="saveNewLengthDate"> <v-icon>$sl-edit</v-icon>ÄNDRA</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/services/api.js'
import DatePicker from '@/components/common/DatePicker'

export default {
  props: {
    show: Boolean,
    appId: Number,
    currentDate: Object
  },
  
  components: {
    DatePicker
  },

  data() {
    return {
      startDate: null,
      endDate: null
    }
  },

  watch: {
    show: {
      handler(oldVal, newVal) {
        this.startDate = this.currentDate?.fromDate
        this.endDate = this.currentDate?.toDate
      },
      immediate: true
    }
  },

  methods: {
    saveNewLengthDate() {
      const data = {
        startDate: this.startDate ?? this.currentDate?.fromDate,
        endDate: this.endDate ?? this.currentDate?.toDate
      }

      const isDateFieldEmpty = Object.values(data).some(o => o === '' || o === null)

      if (isDateFieldEmpty) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      API.extendApprenticeship(this.appId, { data })
        .then(res => {
          this.$emit('saved')
        })
        .catch(err => {
          this.$events.fire('showError', 'Kunde inte förlänga anställningen')
          console.log(err)
        })
    }
  }
}
</script>
